import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { DocumentOverrideApiService } from 'src/api/document-lib/document-override'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createDocumentOverride, createDocumentOverrideFailure, createDocumentOverrideSuccess, deleteDocumentOverride, deleteDocumentOverrideFailure, deleteDocumentOverrideSuccess, loadDocumentOverrides, loadDocumentOverridesFailure, loadDocumentOverridesSuccess, updateDocumentOverride, updateDocumentOverrideFailure, updateDocumentOverrideSuccess } from './document-overrides.actions'

@Injectable()
export class DocumentOverrideEffects {
  private actions$ = inject(Actions)
  private DocumentOverrideApi = inject(DocumentOverrideApiService)
  private toaster = inject(ToasterService)


  loadDocumentOverrides$ = createEffect(() => this.actions$.pipe(
    ofType(loadDocumentOverrides),
    switchMap(action =>
      from(this.DocumentOverrideApi.list()).pipe(
        map(r => loadDocumentOverridesSuccess({
          tableKey: action.tableKey,
          documentOverrides: r.data,
        })),
        catchAndLog(this.toaster, 'Unable to fetch documentOverrides', loadDocumentOverridesFailure
      )))))

  createDocumentOverride$ = createEffect(() => this.actions$.pipe(
    ofType(createDocumentOverride),
    tap(() => this.toaster.progress('Creating document override...')),
    switchMap(action =>
      from(this.DocumentOverrideApi.create(action.override)).pipe(
        map(r => createDocumentOverrideSuccess({ override: r.data })),
        tap(() => this.toaster.success('Document Override created successfully.')),
        catchAndLog(this.toaster, 'Unable to create document override', createDocumentOverrideFailure
      )))))

  updateDocumentOverride$ = createEffect(() => this.actions$.pipe(
    ofType(updateDocumentOverride),
    tap(() => this.toaster.progress('Updating document override...')),
    switchMap(action =>
      from(this.DocumentOverrideApi.update(action.id, action.override)).pipe(
        map(r => updateDocumentOverrideSuccess({ override: r.data })),
        tap(() => this.toaster.success('Document Override updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update document override', updateDocumentOverrideFailure
      )))))

  deleteDocumentOverride$ = createEffect(() => this.actions$.pipe(
    ofType(deleteDocumentOverride),
    tap(() => this.toaster.progress('Deleting document override...')),
    switchMap(action =>
      from(this.DocumentOverrideApi.delete(action.id)).pipe(
        map(r => deleteDocumentOverrideSuccess({ id: action.id })),
        tap(() => this.toaster.success('Document Override deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete document override', deleteDocumentOverrideFailure
      )))))
}
